class DateHelper {
	constructor() {}

	/* Выводит в виде: 18 СЕНТЯБРЯ */
	stampTodm(date) {
		const months = [
			"Января",
			"Февраля",
			"Марта",
			"Апреля",
			"Мая",
			"Июня",
			"Июля",
			"Августа",
			"Сентября",
			"Октября",
			"Ноября",
			"Декабря",
		];
		const dt = new Date(date * 1000);

		return `${dt.getDate()} ${months[dt.getMonth()]}`;
	}

	/* Выводит в виде: Понедельник */
	stampToDay(date) {
		const days = [
			"Воскресенье",
			"Понедельник",
			"Вторник",
			"Среда",
			"Четверг",
			"Пятница",
			"Суббота",
		];
		const dt = new Date(date * 1000);

		return days[dt.getDay()];
	}

	/* Выводит в виде: 18:25 */
	stampToHi(date) {
		const dt = new Date(date * 1000);
		const hours = dt.getUTCHours();
		const minutes = dt.getUTCMinutes();

		return `${hours < 10 ? "0" + hours : hours}:${minutes < 10 ? "0" + minutes : minutes}`;
	}

	toDateInputValue() {
		const local = new Date();
		local.setMinutes(local.getMinutes() - local.getTimezoneOffset());
		return local.toJSON().slice(0, 10);
	}
}

export const dateHelper = new DateHelper();
